import React from 'react';
import { HashRouter, Switch, Route } from 'react-router-dom';
import { observer } from 'mobx-react';
import type ReserveConfirmStore from '@this/src/domain/reserve_confirm_store';
import InputCustomerInformation from './input_customer_information/input_customer_information';
import ConfirmCustomerInformation from './confirm_customer_information/confirm_customer_information';

type Props = {
  store: ReserveConfirmStore;
  isSimpleRequest?: boolean;
  handleBackToSelectClick: () => void;
  handleSaveDraft?: () => void;
  isOnTripsConfirm?: boolean;
  isTripsShinkansenInfoRequired?: boolean;
  handlePaymentSubmit: () => void;
  handleValidationSuccess?: () => void;
  handleBackToStep1Click?: () => void;
};

const ReserveConfirmRoutingsTemplate: React.FC<Props> = ({
  store,
  isSimpleRequest,
  handleBackToSelectClick,
  handleSaveDraft,
  isOnTripsConfirm,
  isTripsShinkansenInfoRequired,
  handlePaymentSubmit,
  handleValidationSuccess,
  handleBackToStep1Click
}) => (
  <HashRouter hashType="noslash">
    <Switch>
      <Route
        exact
        path="/"
        render={() => (
          <InputCustomerInformation
            store={store}
            isSimpleRequest={isSimpleRequest}
            handleBackToSelectClick={handleBackToSelectClick}
            handleSaveDraft={handleSaveDraft}
            isOnTripsConfirm={isOnTripsConfirm || false}
            isTripsShinkansenInfoRequired={isTripsShinkansenInfoRequired}
            handleValidationSuccess={handleValidationSuccess}
          />
        )}
      />
      <Route
        exact
        path="/step2"
        render={() => (
          <ConfirmCustomerInformation
            store={store}
            handleSaveDraft={handleSaveDraft}
            handlePaymentSubmit={handlePaymentSubmit}
            handleBackToStep1Click={handleBackToStep1Click}
            isTripsShinkansenInfoRequired={isTripsShinkansenInfoRequired}
          />
        )}
      />
    </Switch>
  </HashRouter>
);

export default observer(ReserveConfirmRoutingsTemplate);
